/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./XYButtonV2.vue?vue&type=template&id=06498276&scoped=true"
import script from "./XYButtonV2.vue?vue&type=script&lang=js"
export * from "./XYButtonV2.vue?vue&type=script&lang=js"
import style0 from "./XYButtonV2.vue?vue&type=style&index=0&id=06498276&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06498276",
  null
  
)

export default component.exports